/**
 * platform-services role ids.
 *
 * Defined in platform-services `services/libs/types/role.go` and the `roles` table. These
 * are the ids merchant-configurations-api maps onto its own policy role names, so the two
 * sides have to agree on the numbers.
 *
 * Caveat worth knowing: the JWT `roles` claim is a flat array with no tenant qualifier
 * (`libs.GetRoleIDsList` discards the tenant), so "holds Towpay Admin" really means "holds
 * it in at least one tenant". Grants are per tenant; this check cannot see that.
 */
export const TOWPAY_MANAGEMENT_ROLE_ID = 11;
export const TOWPAY_ADMIN_ROLE_ID = 12;

/**
 * @param {Array<number>} roles role ids from the access token
 * @returns {boolean} whether the user may edit and delete merchants
 */
export function isTowpayAdmin(roles) {
  return Array.isArray(roles) && roles.includes(TOWPAY_ADMIN_ROLE_ID);
}

/**
 * @param {Array<number>} roles role ids from the access token
 * @returns {boolean} whether the user may use this app at all
 */
export function canViewMerchants(roles) {
  //  Admin implies management, so nobody has to be granted both.
  return (
    isTowpayAdmin(roles) ||
    (Array.isArray(roles) && roles.includes(TOWPAY_MANAGEMENT_ROLE_ID))
  );
}
